var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSampleImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 61.5,
    r: 61,
    fill: "#FAFAFA",
    stroke: "#E7E7E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_10214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.35 60.9875C53.9355 60.9875 52.7875 62.1355 52.7875 63.55C52.7875 64.9645 53.9355 66.1125 55.35 66.1125C56.7645 66.1125 57.9125 64.9645 57.9125 63.55C57.9125 62.1355 56.7645 60.9875 55.35 60.9875ZM67.65 60.9875C66.2355 60.9875 65.0875 62.1355 65.0875 63.55C65.0875 64.9645 66.2355 66.1125 67.65 66.1125C69.0645 66.1125 70.2125 64.9645 70.2125 63.55C70.2125 62.1355 69.0645 60.9875 67.65 60.9875ZM61.5 41C50.184 41 41 50.184 41 61.5C41 72.816 50.184 82 61.5 82C72.816 82 82 72.816 82 61.5C82 50.184 72.816 41 61.5 41ZM61.5 77.9C52.4595 77.9 45.1 70.5405 45.1 61.5C45.1 60.9055 45.141 60.311 45.2025 59.737C50.0405 57.5845 53.874 53.628 55.883 48.7285C59.5935 53.9765 65.7025 57.4 72.611 57.4C74.21 57.4 75.7475 57.2155 77.2235 56.867C77.654 58.3225 77.9 59.8805 77.9 61.5C77.9 70.5405 70.5405 77.9 61.5 77.9Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_10214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.2,
    height: 49.2,
    fill: "white",
    transform: "translate(36.9004 36.9004)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSampleImg);
export default __webpack_public_path__ + "static/media/ico_sample_img.32d6dfe6bac67cc9beac1432f220c3a7.svg";
export { ForwardRef as ReactComponent };